import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const MigrationMessagingBannerNoConversationsAlert = ({
  name,
  onClose,
  type,
  viewStatusRoute
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "uiAddonConversationsSettings.helpDeskMigration.messagingBanner.titleNoConversations_jsx",
      options: {
        name,
        type
      }
    }),
    closeable: true,
    onClose: onClose,
    children: viewStatusRoute ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        UILink
      },
      message: "uiAddonConversationsSettings.helpDeskMigration.messagingBanner.message_jsx",
      options: {
        href: viewStatusRoute
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "uiAddonConversationsSettings.helpDeskMigration.messagingBanner.message"
    })
  });
};
MigrationMessagingBannerNoConversationsAlert.displayName = 'MigrationMessagingBannerNoConversationsAlert';
export default MigrationMessagingBannerNoConversationsAlert;